export const HEALTH_CHECK_FIELD = '_containerDeployHealthCheck';

export const HEALTH_CHECK_FIELD_KEYS = {
  config: 'healthCheck.config',
} as const;

export const HEALTH_CHECK_FIELD_KEY_LIST = [HEALTH_CHECK_FIELD_KEYS.config] as const;
